import axios from 'axios'
import {config} from '../config'
export const getArticleDetail = (id) =>{
    return axios.get(config.articleDetail+id)
    .then(function (response) {
        return response
    })
    .catch(function (error) {
      console.log(error);
    })
}

